import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class DashboardService {
    static getDashboardTiles() {
        return lastValueFrom(BaseService.get(`dashboard-tiles`));
    }
    static getExpiringDossiers() {
        return lastValueFrom(BaseService.get(`dashboard-expiring-dossiers`));
    }
    static getDossiersByTypeGlobal() {
        return lastValueFrom(BaseService.get(`dashboard-dossiers-by-type-global`));
    }
    static getDossiersByTypeYear() {
        return lastValueFrom(BaseService.get(`dashboard-dossiers-by-type-year`));
    }
    static getNumRecentActivities(days) {
        return lastValueFrom(BaseService.get(`dashboard-num-recent-activities/${days}`));
    }
}
